import type { SVGProps } from "react";
export interface Virus02IconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function Virus02Icon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: Virus02IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M10.457 1.988c.472-1.484 2.613-1.484 3.086 0l.043.154.046.211.096.327a2.674 2.674 0 0 0 3.939 1.344l.183-.115.139-.08c1.384-.714 2.897.8 2.181 2.183l-.079.138-.116.183a2.673 2.673 0 0 0 1.672 4.034l.212.048.152.042c1.485.472 1.485 2.613 0 3.086l-.152.043-.212.046a2.673 2.673 0 0 0-1.672 4.034l.116.184.08.139c.714 1.383-.798 2.896-2.182 2.18l-.14-.078-.182-.116a2.674 2.674 0 0 0-3.94 1.345l-.095.326-.046.213c-.37 1.636-2.641 1.686-3.13.152l-.04-.152-.049-.213a2.673 2.673 0 0 0-3.735-1.834l-.299.163-.183.116c-1.464.924-3.166-.777-2.241-2.241l.116-.184.164-.297a2.676 2.676 0 0 0-1.51-3.642l-.326-.095-.21-.046c-1.69-.382-1.69-2.789 0-3.17l.21-.049.327-.095a2.675 2.675 0 0 0 1.509-3.64l-.164-.299-.116-.183c-.896-1.419.673-3.06 2.103-2.32l.138.079.183.115.299.164a2.674 2.674 0 0 0 3.735-1.835l.049-.21zm1.542 2.285a4.94 4.94 0 0 1-5.464 2.262A4.94 4.94 0 0 1 4.274 12a4.94 4.94 0 0 1 2.261 5.464A4.94 4.94 0 0 1 12 19.726a4.94 4.94 0 0 1 5.464-2.263 4.94 4.94 0 0 1 2.263-5.464 4.94 4.94 0 0 1-2.263-5.464A4.94 4.94 0 0 1 12 4.273Z"
      />
      <path
        fill={color}
        d="M14.718 9.385a2.126 2.126 0 0 1-.218 4.24c-1.1 0-2.005-.836-2.114-1.908l-.01-.216.01-.219A2.125 2.125 0 0 1 14.5 9.375zM12.376 15a1.376 1.376 0 0 1-2.744.14L9.625 15l.007-.14A1.376 1.376 0 0 1 11 13.623l.14.008c.694.07 1.236.656 1.236 1.368Zm-2.001-4a1.375 1.375 0 0 1-2.743.14L7.625 11l.007-.141a1.375 1.375 0 0 1 1.369-1.234l.14.008c.693.07 1.233.655 1.234 1.367"
      />
    </svg>
  );
}
